/**
 * Configuration for Report Action Buttons
 */

const config = [
  {
    action: "customize",
    datasource: "#",
    eventName: "customize-view",
    title: "Click to select and order your report column display",
    icon: "gear",
    label: null,
    className: "btn btn-sm btn-standard",
    attributes: {
      "data-event-category": "View Customization",
      "data-event-action": "Open",
      "aria-label": "Click to select and order your report column display",
    },
  },
  {
    action: "export",
    datasource: "#",
    eventName: "file-export",
    title: "Click to download a copy of this report",
    icon: "download",
    label: null,
    className: "btn btn-sm btn-standard",
    attributes: {
      "data-event-category": "View Export",
      "data-event-action": "Click",
      "aria-label": "Click to download a copy of this report",
    },
  },
];

export { config as default };
